import Vue from 'vue'
import Buefy from 'buefy'
import 'buefy/dist/buefy.css'
// import axios from 'axios'
import App from './App.vue'
import router from './router'
import store from './store'
import '@/styles/style.scss'
import { Amplify } from 'aws-amplify'
import awsconfig from './aws-exports'
import { library } from '@fortawesome/fontawesome-svg-core'
import { fas } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'

Amplify.configure(awsconfig)
// fontawesome.library.add(fas)
library.add(fas)
Vue.component('font-awesome-icon', FontAwesomeIcon)

Vue.use(Buefy)

Vue.config.productionTip = false
// Vue.prototype.$http = axios

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
